import NewAdministrator from "../../../../components/@groups/administrators/NewAdministrator";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function AdministratorGroupNewPage() {

    return (
        <NewAdministrator 
            routeType={routeTypes.admin}
        />
    )
}       